import { FC } from "react";
import { ContentContainerProps } from "./types";

const TextLeftContainer: FC<ContentContainerProps> = ({ children }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 items-center justify-center overflow-hidden [&>*:first-child]:order-2 [&>*:last-child]:order-1 md:[&>*:first-child]:order-none md:[&>*:last-child]:order-none">
      {children}
    </div>
  );
};

export default TextLeftContainer;
